import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseButtonContainer, TagContainer } from "./styled";
import { Flex, FlexSpan } from "../Grid";
import { IconButton } from "../IconButton";
export const Tag = ({ pointer, clearable, onClick, onClear, light, children, ...props }) => {
    return (_jsx(TagContainer, { light: light, pointer: pointer, onClick: onClick, ...props, children: _jsxs(Flex, { alignItems: "center", children: [_jsx(FlexSpan, { children: children }), clearable && (_jsx(CloseButtonContainer, { children: _jsx(IconButton, { icon: "close", size: 12, onClick: onClear }) }))] }) }));
};
